import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../Img/MMOPL-Logo.png';   // ← your logo file name
import './Navbar.css';
import { Nav, Navbar, NavDropdown, Offcanvas, Image } from 'react-bootstrap';

function BasicExample() {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => setExpanded(false);

  const isProductsPage = [
    "/Ocean", "/Air", "/Warehouse", "/Customs", "/Contract", "/Crane"
  ].some(path => location.pathname.startsWith(path));

  return (
    <Navbar
      collapseOnSelect
      expand="xl"
      expanded={expanded}
      onToggle={setExpanded}
      className={`custom-navbar ${scrolled ? 'scrolled' : ''}`}
      variant="light"
    >
      <Navbar.Brand
        as={NavLink}
        to="/"
        onClick={handleNavClick}
        className="ms-3 d-flex align-items-center gap-2 brand-title"
      >
        <Image src={logo} alt="MMOPL Logo" className="brand-logo" />
        <h1 className="gradient-text">MULTI MODAL OVERSEAS PVT LTD</h1>
      </Navbar.Brand>

      <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expanded}`} />
      <Navbar.Offcanvas
        id={`offcanvasNavbar-expand-${expanded}`}
        aria-labelledby={`offcanvasNavbarLabel-expand-${expanded}`}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expanded}`}>
            <Navbar.Brand as={NavLink} to="/" onClick={handleNavClick}>
              <Image src={logo} alt="MMOPL Logo" height={60} />
            </Navbar.Brand>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="justify-content-end flex-grow-1 mx-2">
            <Nav.Link as={NavLink} to="/" className="px-4 fs-6 text-shadow" onClick={handleNavClick}>Home</Nav.Link>
            <Nav.Link as={NavLink} to="/About" className="px-4 fs-6 text-shadow" onClick={handleNavClick}>About</Nav.Link>

            <NavDropdown
              className={`px-4 fs-6 text-shadow ${isProductsPage ? "active" : ""}`}
              title="Services"
              popperConfig={{ strategy: "fixed" }}>
              <NavDropdown.Item className='fs-6 text-shadow' as={NavLink} to="/Global" onClick={handleNavClick}>Ocean Freight</NavDropdown.Item>
              <NavDropdown.Item className='fs-6 text-shadow' as={NavLink} to="/AirChartering" onClick={handleNavClick}>Air Freight</NavDropdown.Item>
              <NavDropdown.Item className='fs-6 text-shadow' as={NavLink} to="/Logistics" onClick={handleNavClick}>Warehousing &amp; Distribution</NavDropdown.Item>
              <NavDropdown.Item className='fs-6 text-shadow' as={NavLink} to="/Customs" onClick={handleNavClick}>Custom Clearance</NavDropdown.Item>
              <NavDropdown.Item className='fs-6 text-shadow' as={NavLink} to="/Cargo" onClick={handleNavClick}>Contract Logistics</NavDropdown.Item>
              <NavDropdown.Item className='fs-6 text-shadow' as={NavLink} to="/Vessel" onClick={handleNavClick}>Crane Rentals</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={NavLink} to="/Industries" className="px-4 fs-6 text-shadow" onClick={handleNavClick}>Industries</Nav.Link>
            <Nav.Link as={NavLink} to="/Contact" className="px-4 fs-6 text-shadow" onClick={handleNavClick}>Contact</Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Navbar.Offcanvas>
    </Navbar>
  );
}

export default BasicExample;